import component from './ct-select-input'

const com = {
    install (Vue) {
        Vue.component('ct-select-input', component)
    }
}
export default com